import { Tooltip, type TooltipProps } from "@mui/material";
import React from "react";
export default function CloseArrowTooltip({ ...tooltipProps }: TooltipProps) {
  return (
    <Tooltip
      arrow
      placement={"top"}
      disableInteractive
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      }}
      {...tooltipProps}
    >
      {tooltipProps.children}
    </Tooltip>
  );
}
